
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/spellify/hard",
      function () {
        return require("private-next-pages/spellify/hard.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/spellify/hard"])
      });
    }
  